import { useLocation } from 'react-router-dom';

const useObjectiveableIdFromUrl = () => {
  const location = useLocation();
  const urlAsArray = location.pathname.split('/');
  const paths = ['courses', 'on-demand', 'live'];

  const pathFound = paths.find((path) => urlAsArray.includes(path));

  if (pathFound) {
    let objectiveableId = urlAsArray[urlAsArray.indexOf(pathFound) + 1];

    if (objectiveableId?.includes('-')) {
      [objectiveableId] = objectiveableId.split('-');
    }

    return Number(objectiveableId);
  }
};

export default useObjectiveableIdFromUrl;
